import { createInertiaApp, type ResolvedComponent } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
import Layout from '~/components/application/Layout';

createInertiaApp({
  resolve: async name => {
    const pages = import.meta.glob<{ default: ResolvedComponent }>('../pages/**/*.tsx');
    return (await pages[`../pages/${name}.tsx`]()).default;
  },
  layout: () => Layout,
  setup({ el, App, props }) {
    createRoot(el!).render(<App {...props} />);
  },
});
